import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useSelector } from "react-redux";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useEffect, useState } from "react";

function ProductDetailAccordion() {
  const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    setExpanded(false);
  }, [PRODUCTDETAILS?.id]);

  const renderTnc = (tnc) => {
    if (!tnc) return null;

    // HTML entities decode karne ke liye
    const decodeHtml = (value) => {
      const textarea = document.createElement("textarea");
      textarea.innerHTML = value;
      return textarea.value;
    };

    // HTML <br> ko newline mein convert karo
    const plainText = decodeHtml(tnc)
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n")
      .replace(/<p[^>]*>/gi, "")
      .replace(/\r\n/g, "\n")
      .replace(/\r/g, "\n");

    // HTML tags agar koi remaining hain to remove karo
    const cleanText = plainText.replace(/<[^>]*>/g, "");

    // Har line ko clean karo
    const lines = cleanText
      .split("\n")
      .map((line) => line.trim())
      .filter(Boolean);

    return (
      <Box
        sx={{
          fontFamily: "Be Vietnam Pro",
          fontSize: "13px",
          lineHeight: 1.8,

          "& ol": {
            paddingLeft: "20px",
            margin: 0,
          },

          "& ul": {
            paddingLeft: "20px",
            margin: 0,
          },

          "& li": {
            marginBottom: "6px",
          },
        }}
      >
        <Box
          component="ol"
          sx={{
            paddingLeft: "20px",
            margin: 0,
          }}
        >
          {lines.map((line, index) => {
            // Main numbered point: 1. 2. 3. etc.
            const numberedPoint = line.match(/^(\d+)\.\s*(.*)$/);

            if (numberedPoint) {
              return <li key={index}>{numberedPoint[2]}</li>;
            }

            // Agar a., b., c. ya i., ii. type point ho
            return (
              <Box
                component="div"
                key={index}
                sx={{
                  marginLeft: "8px",
                  marginBottom: "6px",
                }}
              >
                {line}
              </Box>
            );
          })}
        </Box>
      </Box>
    );
  };

  return (
    <>
      <Box
        sx={{
          width: {
            xs: "100%",
            sm: "100%",
          },
          ml: {
            xs: 0,
            sm: 0,
          },
          mr: {
            xs: 0,
            sm: 0,
          },
          maxWidth: {
            md: "400px",
            lg: "500px",
          },
        }}
      >
        <Accordion
          expanded={expanded === "redeem"}
          onChange={handleChange("redeem")}
          sx={{
            mb: 2,
            background: "#F5F5F5",
            border: "1.8px solid #E4C18F",
            // boxShadow: '0 8px 16px rgba(0,0,0,0.10)',
            boxShadow: "none",
            borderRadius: "10px !important",
            overflow: "hidden",
            "&:before": {
              display: "none",
            },
            "&:first-of-type": {
              borderRadius: "10px !important",
            },
            "&:last-of-type": {
              borderRadius: "10px !important",
            },
            "& .MuiSvgIcon-root": {
              color: "white",
              fontSize: 22,
            },
          }}
        >
          <AccordionSummary
            expandIcon={<KeyboardArrowDownIcon />}
            sx={{
              minHeight: "48px !important",

              "& .MuiAccordionSummary-content": {
                margin: "8px 0",
              },

              "&.Mui-expanded": {
                minHeight: "48px !important",
              },

              "&.Mui-expanded .MuiAccordionSummary-content": {
                margin: "8px 0",
              },

              "& .MuiAccordionSummary-expandIconWrapper": {
                backgroundColor: "#E4C18F",
                color: "primary.main",
                borderRadius: "50%",
                width: 28,
                height: 28,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              },
            }}
          >
            <Typography
              component="span"
              sx={{
                color: "#000000",
                fontSize: { xs: "13px", md: "14px", lg: "16px" },
                fontWeight: 500,
                fontFamily: "Be Vietnam Pro",
              }}
            >
              How To Redeem
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {renderTnc(PRODUCTDETAILS?.redemptionInfo)}
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "tnc"}
          onChange={handleChange("tnc")}
          sx={{
            background: "#F5F5F5",
            border: "1.8px solid #E4C18F",
            borderRadius: "10px !important",
            overflow: "hidden",
            // boxShadow: '0 8px 16px rgba(0,0,0,0.10)',
            boxShadow: "none",
            "&:before": {
              display: "none",
            },
            "&:first-of-type": {
              borderRadius: "10px !important",
            },
            "&:last-of-type": {
              borderRadius: "10px !important",
            },
          }}
        >
          <AccordionSummary
            expandIcon={<KeyboardArrowDownIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
            sx={{
              "& .MuiAccordionSummary-expandIconWrapper": {
                backgroundColor: "#E4C18F",
                color: "primary.main",

                borderRadius: "50%",
                width: 28,
                height: 28,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              },
              "& .MuiSvgIcon-root": {
                color: "white",
                fontSize: 22,
              },
            }}
          >
            <Typography
              component="span"
              sx={{
                color: "#000000",
                fontSize: { xs: "13px", md: "14px", lg: "16px" },
                fontWeight: 500,
                fontFamily: "Be Vietnam Pro",
              }}
            >
              Term & conditions
            </Typography>
          </AccordionSummary>
          <AccordionDetails>{renderTnc(PRODUCTDETAILS?.tnc)}</AccordionDetails>
        </Accordion>

        {/* Newly added code */}

        <Accordion
          expanded={expanded === "details"}
          onChange={handleChange("details")}
          sx={{
            mt: 2,
            background: "#F5F5F5",
            border: "1.8px solid #E4C18F",
            // boxShadow: '0 8px 16px rgba(0,0,0,0.10)',
            boxShadow: "none",
            borderRadius: "10px !important",
            overflow: "hidden",
            "&:before": {
              display: "none",
            },
            "&:first-of-type": {
              borderRadius: "10px !important",
            },
            "&:last-of-type": {
              borderRadius: "10px !important",
            },
            "& .MuiSvgIcon-root": {
              color: "white",
              fontSize: 22,
            },
          }}
        >
          <AccordionSummary
            expandIcon={<KeyboardArrowDownIcon />}
            sx={{
              minHeight: "48px !important",

              "& .MuiAccordionSummary-content": {
                margin: "8px 0",
              },

              "&.Mui-expanded": {
                minHeight: "48px !important",
              },

              "&.Mui-expanded .MuiAccordionSummary-content": {
                margin: "8px 0",
              },

              "& .MuiAccordionSummary-expandIconWrapper": {
                backgroundColor: "#E4C18F",
                color: "primary.main",
                borderRadius: "50%",
                width: 28,
                height: 28,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              },
            }}
          >
            <Typography
              component="span"
              sx={{
                color: "#000000",
                fontSize: { xs: "13px", md: "14px", lg: "16px" },
                fontWeight: 500,
                fontFamily: "Be Vietnam Pro",
              }}
            >
              Product Details
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box
              sx={{
                fontFamily: "Be Vietnam Pro",
                fontSize: "13px",
                lineHeight: 2,
              }}
            >
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "110px 15px 1fr",
                }}
              >
                <span>Product Type</span>
                <span>:</span>
                <span>Digital Gift Card</span>

                <span>Delivery</span>
                <span>:</span>
                <span>Digital/Instant Email</span>

                <span>Region</span>
                <span>:</span>
                {/* <span>{PRODUCTDETAILS?.region || "UAE"}</span> */}
                { <span>{ "UAE"}</span> }

                <span>Redemption</span>
                <span>:</span>
                <span>As Per {PRODUCTDETAILS?.name} Redemption</span>

                <span>Validity</span>
                <span>:</span>
                <span>As Per {PRODUCTDETAILS?.name} T&amp;C</span>

                <span>Payment</span>
                <span>:</span>
                <span>Secure</span>
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  );
}

export default ProductDetailAccordion;
